import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Loader2, LogIn } from 'lucide-react';
import { booksLogin, saveBooksSession, errMsg } from './api';

const BooksLoginPage = () => {
  const nav = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      const res = await booksLogin(email, password);
      saveBooksSession(res.token, res.user, res.tenant);
      const params = new URLSearchParams(location.search);
      const next = params.get('next');
      nav(next && next.startsWith('/books/app') ? next : '/books/app/dashboard');
    } catch (e) {
      setError(errMsg(e));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#e2ede6] flex items-center justify-center px-4 py-12">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-3xl shadow-xl overflow-hidden">
        <div className="bg-[#0b1a2e] text-white p-6">
          <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 32, fontWeight: 500, color: '#7bbf95' }}>Emerald Books</div>
          <div className="text-xs tracking-[0.3em] text-white/50 uppercase mt-1">Sign in</div>
        </div>
        <div className="p-6 space-y-4">
          {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded p-2">{error}</div>}
          <label className="block">
            <div className="text-xs font-semibold uppercase tracking-widest text-[#0b1a2e]/70 mb-1">Email</div>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="books-login-email" required
              className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" />
          </label>
          <label className="block">
            <div className="text-xs font-semibold uppercase tracking-widest text-[#0b1a2e]/70 mb-1">Password</div>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="books-login-password" required
              className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm" />
          </label>
          <button type="submit" disabled={busy} data-testid="books-login-submit"
            className="w-full py-2.5 bg-[#0f5c3d] text-white rounded-full font-semibold disabled:opacity-50 inline-flex items-center justify-center gap-2">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />}
            Sign in
          </button>
          <div className="flex items-center justify-between text-xs text-[#0b1a2e]/50">
            <span>New here? <Link to="/books/signup" className="text-[#0f5c3d] font-semibold">Set up your books</Link></span>
            <Link to="/books/forgot-password" className="text-[#0f5c3d] font-semibold" data-testid="books-login-forgot-link">
              Forgot password?
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
};

export default BooksLoginPage;
